import { defineStore } from "pinia";

export const useWidgetStore = defineStore("widgetStore", {
  state: () => ({
    typeEdit: "list",
    hdriEdit: null,
    hdris: null,
    initialItem: 0,
    getHdriTrigger: 0,
    currentWidget: {},
    triggerTakeOff: 0,
    errorSize: false,
    ZVClass: {},
    isLoadWidget: false,
    widgetId: null,
    widgetPreviewTrigger: 0,
  }),
  actions: {
    setValue(keyValue) {
      if (keyValue?.key in this) {
        this[keyValue.key] = keyValue.value;
      }
    },
    updateAnimation(animation) {
      const animationIndex = this.currentWidget.animations.findIndex(
        (_animation) => _animation.id === animation.id
      );

      if (animationIndex !== -1) {
        this.currentWidget.animations.splice(animationIndex, 1, animation);
      } else {
        console.warn(`Анимация с id ${animation.id} не найдена.`);
      }
    },
    SET_VALUE(keyValue) {
      this.setValue(keyValue);
    },
    UPDATE_ANIMATION(material) {
      this.updateAnimation(material);
    },
    setCurrentWidget(widget) {
      this.currentWidget = widget;
    },
  },
});

export default useWidgetStore;
